export enum TabSize {
    Small = "Small",
    Medium = "Medium",
    Large = "Large"
}

export enum StepProgressKind {
    Inactive = "Inactive",
    Active = "Active",
    Completed = "Completed"
}

export enum TabKind {
    Default = "Default",
    Stepper = "Stepper"
}